import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=d5123e30&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=d5123e30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5123e30",
  null
  
)

export default component.exports